import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a69d89a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "rdd-header__title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rdd-header__icon" }, null, -1))
const _hoisted_5 = { class: "list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownMenu = _resolveComponent("DropDownMenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["restaurants-drop-down", {
      'restaurants-drop-down--is-opened': _ctx.isOpened,
      'restaurants-drop-down--is-image-title': _ctx.isImageTitle,
    }])
  }, [
    _createVNode(_component_DropDownMenu, {
      ref: "dropDownMenu",
      onToggle: _cache[1] || (_cache[1] = (state) => _ctx.toggle(state)),
      onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle(false)))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass([
            'restaurants-drop-down__header rdd-header',
            { 'rdd-header--is-image-title': _ctx.isImageTitle },
          ])
        }, [
          (_ctx.isImageTitle)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
              'rdd-header__image-title',
              { 'rdd-header__image-title--with-arrow': !_ctx.isFiltersOpen },
            ])
              }, [
                (_ctx.selectedRestaurant?.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.selectedRestaurant?.logo
                    }, null, 8, _hoisted_1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, " Все бренды и бары "))
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.selectedRestaurant?.name || _ctx.DEFAULT_TITLE), 1)),
          _hoisted_4
        ], 2)
      ]),
      items: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurants, (restaurant) => {
            return (_openBlock(), _createElementBlock("div", {
              key: restaurant.id,
              class: "list__item",
              onClick: ($event: any) => (_ctx.select(restaurant.id))
            }, [
              _createElementVNode("img", {
                src: restaurant.logo,
                alt: ""
              }, null, 8, _hoisted_7)
            ], 8, _hoisted_6))
          }), 128)),
          _createElementVNode("div", {
            class: "list__item list__item--to-all",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.select()))
          }, " Все бренды и бары ")
        ])
      ]),
      _: 1
    }, 512)
  ], 2))
}